const DefaultPlaceholder = () => (
  <p>
    <span className="text-gray-500 cursor-pointer border-b-2 border-gray-400 ">Click here</span> or
    drag a file to this area to upload
  </p>
);

export default DefaultPlaceholder;
